export const GENERAL_PROJECT_SETTINGS = {
	color: { hex: '#4d4f5c' },
	buttonColor: { hex: '#ffffff' },
	buttonColor2: { hex: '#4d4f5c' },
	buttonBackgroundColor: { hex: '#4d4f5c' },
	backgroundImage: '',
	previewImage: '',
};